<template>
  <div>
    <app-header ref="header">
      <div slot="right"></div>
    </app-header>
    <div class="app-body">
      <el-container class="app-container mt-4">
        <el-main>
          <div class="app-head">
            <div>
              <h4 class="app-title">查询教师开户申请</h4>
              <div class="app-desc">可查询教师是否已申请开户或开户申请状态。</div>
            </div>
            <div>
              <router-link to="/joint">返回教师开户申请</router-link>
            </div>
          </div>
          <div class="app-form">
            <div class="mt-3">
              <el-form ref="form" :model="form" :rules="rules" label-width="120px" @submit.native.prevent="onSubmit1">
                <el-form-item label="教师姓名或手机" prop="query">
                  <el-input v-model="form.query" @keyup.native.enter="onSubmit('form')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit('form')">开始查询</el-button>
                  <el-button @click="doCancel">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div v-if="form.query" class="query-result mt-4">
            <h4>查询：<small>{{ form.query }}</small></h4>
            <div v-if="isempty">
              <el-alert
                title="未查询到任何结果"
                type="error">
              </el-alert>
            </div>
            <ul class="mt-4">
              <li v-for="item in list" :key="item.id" class="result" @click="view(item)">
                <div class="result-title">{{ item.name }}</div>
                <div class="result-desc">
                  <span class="mr-4">申请时间：{{ item.createtime }}</span>
                  <span>状态：<el-tag size="small" :type="organizationStatusType(item)">{{ organizationjoinstatus[item.status] }}</el-tag></span>
                </div>
              </li>
            </ul>
          </div>
        </el-main>
      </el-container>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import { organizationStatusType } from '@/business/mixin/global';
import AppHeader from '../app-header';
import AppFooter from '../app-footer';
export default {
  mixins: [tools],
  components: { AppHeader, AppFooter },
  data () {
    return {
      form: {
        query:''
      },
      rules: {
        query: { required: true, message: '请输入教师姓名或手机', trigger: 'blur' },
      },
      list: [],
      isempty: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      organizationjoinstatus: [types.STATUS.organizationjoinstatus],
    })
  },
  created () {
  },
  mounted() {
  },
  activated () {
    if (!this.organizationjoinstatus || !Object.keys(this.organizationjoinstatus).length) {
      this.$store.dispatch(types.STATUS.organizationjoinstatus);
    }
  },
  methods: {
    onSubmit1() {
      return false;
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          this.doPost({
            url: 'vue/teacher/join/query',
            data: {query: this.form.query},
            okcb: (json) => {
              this.list = json;
              this.isempty = !json.length;
            },
            cb: () => {
              this.$nextTick(() => this.loading = false);
            }
          });
        }
      });
    },
    doCancel() {
      this.$router.push('/joint');
    },
    view(item) {
      this.$router.push('/joint/view/'+ item.id);
    },
    organizationStatusType(item) {
      return organizationStatusType(item.status);
    }
  }
}
</script>
<style lang="less" scoped>
.app {
  &-head {
    .flex();
    justify-content:space-between;
  }
  &-title {
    font-size:2rem;
  }
  &-desc {
    color:#555;
  }
  &-form {
    margin-top:2rem;
    padding:2rem;
    background-color:#fff;
    .shadow-black(0 0 6px 0, .03);
    form {
      .el-form-item {
        max-width:600px;
        &.textarea {
          max-width:1000px;
        }
      }
    }
  }
}
.query-result {
  padding:2rem;
  background-color:#fff;
  .h4 {
    font-size:1.3rem;
  }
  .result {
    padding:.5rem 0;
    cursor:pointer;
    &:hover {
      background-color: #f6f6f6;
    }
    &-title {
      font-size:1.2rem;
    }
    &-desc {
      .flex-center-v();

    }
  }
}
</style>